import { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { getSingleChoiceValue } from '@r-and-a-shared-ui/common-kontent-client/utils';
export const iframe = (entry: PLAYER_PORTALS_MODELS.IFrame) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }

  const { elements } = entry || {};

  const widthUnit = getSingleChoiceValue(elements?.width_unit);
  const mappedWidthUnit = widthUnit === 'percent' ? '%' : 'px';

  return {
    title: elements.title?.value,
    src: elements?.src.value,
    width: elements?.width.value,
    widthUnit: mappedWidthUnit,
    height: elements?.height.value,
  };
};

export default iframe;
